export enum EWCAmplitude {
  WC_SIGNUP_CANCEL_REQUEST_INVITE = 'signupCancelrequestinvite_action' // (ModalBrokerInvitation): Cuando un asesor cancela la solicitud de invitación que realizo hacia una agencia
}
